import { CountryCode, countryCodes } from '@dixa/lib-shared-habla';
import { getCountryCodeFromPhoneNumber } from 'lib-shared-phone-numbers';

import type { PhoneNumber } from 'apis/numbers';

const flagCountryCodes: ReadonlySet<string> = new Set(countryCodes);

const isFlagCountryCode = (code: string | undefined): code is CountryCode =>
  code !== undefined && flagCountryCodes.has(code);

/**
 * Returns the country of a phone number of the organization, in lower case.
 *
 * The country from the backend wins, because the backend can store a country
 * that overrides the one detected from the number. The country is detected
 * from the number when the backend has no country, or one without a flag.
 */
export function getPhoneNumberCountry(
  phoneNumber: Pick<PhoneNumber, 'e164_format' | 'iso_country_code'>,
): CountryCode | undefined {
  const backendCountryCode = phoneNumber.iso_country_code?.toLowerCase();

  return isFlagCountryCode(backendCountryCode)
    ? backendCountryCode
    : getCountryCodeFromPhoneNumber(phoneNumber.e164_format);
}
